import React from 'react';
import { Link } from "react-router-dom";
import "../scss/layout/Nav.scss";

const Nav = () => {
    return (
        <nav className="nav nav--primary">
            <div className="nav__item"><Link to="/samoloty" replace>Samoloty</Link></div>
            <div className="nav__item"><Link to="/" replace>Katastrofy lotnicze</Link></div>
            <div className="nav__item"><Link to="/" replace>Linie lotnicze</Link></div>
        </nav>
    )
}

export default Nav;